import React from "react";
import { useLocation } from "react-router-dom";
import ESModuleSubtopic from "../ESModuleSubtopic";

const OverviewEmbeddedSystems = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || {
    subtopics: [],
    subjectPath: "",
  };

  return (
    <ESModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Overview of Embedded Systems, Design Challenges, Embedded Processor Technology, Hardware Design"
      videos={[
        "https://www.youtube.com/embed/JO4AEkOVF2M",
        "https://www.youtube.com/embed/-eK_niCyf5Y",
        "https://www.youtube.com/embed/kDcbFP4tMTE",
        "https://www.youtube.com/embed/7x9CDXM4DgM",
        "https://www.youtube.com/embed/5h_bRhrY-sM",
      ]}
      takeaways={[]}
      questions={[
        "1)Enumerate the design challenges in Embedded Systems",
        "2) Justify why a desktop system could not be defined as an embedded system. Illustrate architecture of PIC microcontroller with sufficient explanation",
        "3)Identify the various features for the following embedded system i. Smart Washing Machine ii. Green House Monitoring iii. Textile Manufacturing Classify the above systems with respect to scalability with necessary justifications",
        "4) Draw the block diagram of an embedded system and compare and contrast Microprocessor and Microcontroller? Explain the architecture of 8051 Microcontroller with neat sketch?",
        "5)compare and contrast desktop systems with an embedded systems and explain the architecture of 8051 microcontroller with neat sketch?",
        "6)How do the different execution modes in ARM architecture optimize system performance, enable efficient multitasking, and ensure robust security in embedded and real-time applications?"
      ]}
      exampleVideos={[]}
    />
  );
};

export default OverviewEmbeddedSystems;
